"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorMessageFromError = exports.postRequest = exports.trimUndefined = void 0;
const trimUndefined = (obj) => Object.entries(obj).reduce((result, [key, value]) => value === undefined ? result : ((result[key] = value), result), {});
exports.trimUndefined = trimUndefined;
const postRequest = (url, body, token, headers) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let form;
    if (body) {
        if (headers &&
            headers["Content-Type"] === "application/x-www-form-urlencoded") {
            form = new URLSearchParams();
        }
        else {
            form = new FormData();
        }
        Object.keys((0, exports.trimUndefined)(body)).forEach((key) => Array.isArray(body[key])
            ? form.append(key, JSON.stringify(body[key]))
            : form.append(key, body[key]));
    }
    const response = yield fetch(url, {
        method: "POST",
        headers: token
            ? Object.assign({ Authorization: `Bearer ${token}` }, headers) : Object.assign({}, headers),
        body: form,
    });
    if (String(response.status).startsWith("5")) {
        throw new Error(response.statusText);
    }
    const data = yield response.json();
    if (data.status === 400 && data.invalid_fields) {
        throw new Error((_a = Object.values(data === null || data === void 0 ? void 0 : data.invalid_fields)) === null || _a === void 0 ? void 0 : _a.toString());
    }
    if (String(data.status).startsWith("4")) {
        throw new Error(data.message);
    }
    return data;
});
exports.postRequest = postRequest;
const createErrorMessageFromError = (data) => {
    return (data === null || data === void 0 ? void 0 : data.invalid_fields)
        ? Object.values(data.invalid_fields)
            .map((item) => {
            if (Array.isArray(item)) {
                return item.join(", ");
            }
            return item;
        })
            .join(", ")
        : "";
};
exports.createErrorMessageFromError = createErrorMessageFromError;
